<template>
    <console-layout width="100%" max-width="1024">
        
        <console-title>
            <span>보물찾기 설정</span>
        </console-title>

        <console-body>
            <v-layout class="align-end">
                <v-spacer/>
                <span class="mx-1">
                    <v-btn color="primary" @click="reset">
                        보물찾기초기화
                    </v-btn>
                </span>
                <span class="mx-1">
                    <v-btn color="primary" @click="test">
                        보물찾기테스트
                    </v-btn>
                </span>
                <span class="mx-1">
                    <v-btn color="primary" @click="stopTest">
                        보물찾기중지
                    </v-btn>
                </span>
            </v-layout>
    
            <v-data-table :items="configs" :headers="configsHeaders" hide-default-footer disable-sort class="mt-2 elevation-1">
                <template #[`item.actions`]="{item}">
                    <v-icon small @click="edit(item)">mdi-pencil</v-icon>
                    <v-icon small class="ml-1" @click="remove(item)">mdi-delete</v-icon>
                </template>
                <template #[`item.createdAt`]="{item}">
                    {{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
                </template>
                <template #[`item.image`]="{item}">
                    <v-img :src="item.image" max-width="96" height="96" contain class="ma-auto"/>
                </template>
                <template #[`item.percentage`]="{item}">
                    {{ item.percentage }}%
                </template>
            </v-data-table>

            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-4" @input="search(true)"/>
        </console-body>

        <v-btn color="accent" fab fixed bottom right dark @click="create"><v-icon>mdi-pencil</v-icon></v-btn>
    </console-layout>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api";
import { mdiMicrosoftExcel } from "@mdi/js";

export default {
    data(){
        return {
            mdiMicrosoftExcel,

            showSearch: true,

            filter: {
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "업체명", value: "companyName" },
            ],

            page: +this.$route.query.page || 1,
            pageCount: 0,
            limit: 10,

            configs: [],
            configsHeaders: [
                { text: "랭킹", value: "ranking", align: "center" },
                { text: "경품명", value: "name", align: "center" },
                { text: "경품 이미지", value: "image", align: "center" },
                { text: "경품 재고", value: "stock", align: "center" },
                { text: "당첨 회수", value: "stockCount", align: "center" },
                { text: "경품 확률", value: "percentage", align: "center" },
                { text: "생성일자", value: "createdAt", align: "center", width: 200 },
                { text: "actions", value: "actions", align: "center", width: 100 },
            ], 
            interval: null
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            await this.search();
        },

        async search(){
            let { summary, configs } = await api.console.hunt.configs.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                },
                params: this.filter
            });

            this.configs = configs;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

        create(){
            this.$router.push(`/console/hunt/setting/create`);
        },

        edit(config){
            this.$router.push(`/console/hunt/setting/${config._id}`);
        },

        async remove(config){
            if(confirm("정말 삭제하시겠습니까?")){
                await api.console.hunt.configs.delete(config);
                alert("삭제되었습니다");
                this.search();
            }
        },
        async reset() {
            if(confirm("보물찾기 당첨기록 및 보물찾기설정을 초기화 하시겠습니까?")){
                await api.console.hunt.configs.reset();
                await this.init();
                alert("보물찾기이 초기화 되었습니다.");
            }
        },
        async test() {
            if(confirm("보물찾기 테스트를 진행하시겠습니까?")) {
                this.interval = setInterval( async () => {
                    let { config, randomPercent } = await api.console.hunt.configs.test()
                    console.log({name: config.name, randomPercent});
                    // alert(`당첨 상품은 ${config.name}입니다`)
                    await this.search()
                }, 300)
            }
        },
        stopTest() {
            if(confirm("보물찾기 테스트를 중지하시겠습니까?")) {
                clearInterval(this.interval)
            }
        }
    }
}
</script>